import http from 'common/http'

export interface OrderLineItem {
  sku: string
  name: string
  quantity: number
  unitPrice?: number
  currency?: string
}

export interface Order {
  id: string
  tenantId: string
  userId: string
  orderDetails: OrderLineItem[]
  createdAt: string
  updatedAt: string
  invoicedAt?: string
  shippedAt?: string
}

export interface OrdersResponse {
  results: Order[]
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

export interface Product {
  sku: string
  name: string
  description?: string
  price: number
  currency: string
  discountedPrice?: number
  effectiveAt?: string
  expiredAt?: string
  category: string
  rank: number
}

export const fetchOrders = (page = 1, pageSize = 20) => {
  return http
    .get('/order', {
      params: {
        page,
        pageSize: Math.min(pageSize, 100),
      },
    })
    .then((res) => res.data)
}

export const createOrder = (
  orderDetails: Array<{ sku: string; quantity: number }>,
) => {
  return http
    .post('/order', {
      orderDetails,
    })
    .then((res) => res.data)
}

export const updateOrder = (
  id: string,
  data: Partial<{
    orderDetails: OrderLineItem[]
    invoicedAt: string
    shippedAt: string
  }>,
) => {
  return http.put(`/order/${id}`, data).then((res) => res.data)
}

export const deleteOrder = (id: string) => {
  return http.delete(`/order/${id}`).then(() => {
    return { id }
  })
}

export const fetchProducts = () => {
  return http.get('/product').then((res) => res.data)
}
